import { render } from "./vm-force-reset-policy.vue?vue&type=template&id=6ce6a164&scoped=true"
import script from "./vm-force-reset-policy.vue?vue&type=script&lang=js"
export * from "./vm-force-reset-policy.vue?vue&type=script&lang=js"

import "./vm-force-reset-policy.vue?vue&type=style&index=0&id=6ce6a164&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce6a164"]])

export default __exports__